import React, { useEffect, useRef, useState } from "react";
import { useUnidade } from "@/contexts/UnidadeContext";
import { MapPin, ChevronDown, Check } from "lucide-react";

export default function UnidadeSelector() {
  const { unidade, setUnidade, unidades, isAdmin, currentLabel } = useUnidade();
  const [open, setOpen] = useState(false);
  const ref = useRef(null);

  useEffect(() => {
    const onDoc = (e) => { if (ref.current && !ref.current.contains(e.target)) setOpen(false); };
    document.addEventListener("mousedown", onDoc);
    return () => document.removeEventListener("mousedown", onDoc);
  }, []);

  const pick = (id) => {
    setUnidade(id);
    setOpen(false);
    // Hard reload so every loaded page re-fetches with the new header.
    // This is the simplest reliable approach across all modules.
    setTimeout(() => window.location.reload(), 50);
  };

  return (
    <div ref={ref} className="relative" data-testid="unidade-selector">
      <button
        onClick={() => setOpen((v) => !v)}
        className="inline-flex items-center gap-2 bg-white border-2 border-[#3D6B57] px-3 py-1.5 hover:bg-[#3D6B57] hover:text-white transition-colors"
        data-testid="unidade-btn"
      >
        <MapPin className="w-4 h-4" />
        <div className="text-left">
          <div className="font-mono-data text-[8px] uppercase tracking-widest opacity-70 leading-none">Unidade</div>
          <div className="font-display font-bold text-xs uppercase tracking-wider leading-tight">{currentLabel}</div>
        </div>
        <ChevronDown className={`w-4 h-4 transition-transform ${open ? "rotate-180" : ""}`} />
      </button>

      {open && (
        <div className="absolute right-0 mt-2 w-64 bg-white border-2 border-[#111] shadow-[4px_4px_0_0_#0A1F14] z-50">
          <div className="font-mono-data text-[10px] uppercase tracking-widest text-[#555] px-3 py-2 border-b-2 border-[#111]">Selecionar Unidade</div>
          {unidades.map((u) => (
            <button
              key={u.id}
              onClick={() => pick(u.id)}
              className={`w-full px-3 py-2 text-left text-sm flex items-center justify-between hover:bg-[#E8F0EA] ${unidade === u.id ? "bg-[#F4F8F5] font-bold" : ""}`}
              data-testid={`unidade-opt-${u.id}`}
            >
              <span>{u.nome}</span>
              {unidade === u.id && <Check className="w-4 h-4 text-[#3D6B57]" />}
            </button>
          ))}
          {isAdmin && (
            <button
              onClick={() => pick("all")}
              className={`w-full px-3 py-2 text-left text-sm flex items-center justify-between hover:bg-[#FFE9D9] border-t-2 border-dashed border-[#111] ${unidade === "all" ? "bg-[#FFE9D9] font-bold" : ""}`}
              data-testid="unidade-opt-all"
            >
              <span className="text-[#7C2D12]">Todas as Unidades (admin)</span>
              {unidade === "all" && <Check className="w-4 h-4 text-[#7C2D12]" />}
            </button>
          )}
        </div>
      )}
    </div>
  );
}
